import { FollowupDraft } from "@/types/FollowupDraft";
import { CustomTask } from "@/types/followupTask";
import { Client } from "@/types/page";
import { createContext, useContext } from "react";

export type DraftState = {
    draft: FollowupDraft | null;
    isProcessing: boolean;
    isBoardUnmodified: boolean;
};

export const initialDraftState: DraftState = {
    draft: null,
    isProcessing: false,
    isBoardUnmodified: false,
};

export const initialAiDraftContext = {
    getDraftState: (_otherUserId: number): DraftState => initialDraftState,
    getDraft: async (_client: Client, _customTasks?: CustomTask[]) => {},
    generateAllDrafts: async () => {},
    clearDraft: (_otherUserId: number, _probablyUsed: boolean) => {},
    setStarsScore: (_otherUserId: number, _rating: number | null) => {},
    feedbackModalDraft: undefined as FollowupDraft | undefined,
    setFeedbackModalDraft: (_draft?: FollowupDraft) => {},
};

export const AiDraftContext = createContext(initialAiDraftContext);

export function useAiDraft(otherUserId: number) {
    const {
        getDraftState,
        getDraft,
        clearDraft,
        setStarsScore,
        feedbackModalDraft,
        setFeedbackModalDraft,
    } = useContext(AiDraftContext);

    const { draft, isProcessing } = getDraftState(otherUserId);

    return {
        draft,
        isProcessing,
        getDraft,
        clearDraft: (probablyUsed: boolean) =>
            clearDraft(otherUserId, probablyUsed),
        setStarsScore: (rating: number | null) =>
            setStarsScore(otherUserId, rating),
        feedbackModalDraft,
        setFeedbackModalDraft,
    };
}
